import { type Static, Type } from "@sinclair/typebox"
import {
  GamerTagRegistrySchema,
  PlayerProfileStoreSchema,
} from "../schemas/profiles"
import { PublicPlayerProfileListSchema } from "../schemas/social"

export const PLAYER_PROFILES_STORAGE_KEY = "craft-force.player-profiles"
export const GAMER_TAG_REGISTRY_STORAGE_KEY = "craft-force.gamer-tag-registry"
export const PUBLIC_PLAYER_PROFILES_STORAGE_KEY =
  "craft-force.public-player-profiles"

export const PLAYER_PROFILES_STORAGE_VERSION = 1
export const GAMER_TAG_REGISTRY_STORAGE_VERSION = 1
export const PUBLIC_PLAYER_PROFILES_STORAGE_VERSION = 1

export const PlayerProfileStoreStateSchema = PlayerProfileStoreSchema
export type PlayerProfileStoreState = Static<
  typeof PlayerProfileStoreStateSchema
>

export const GamerTagRegistryStateSchema = GamerTagRegistrySchema
export type GamerTagRegistryState = Static<typeof GamerTagRegistryStateSchema>

export const PublicPlayerProfilesStateSchema = PublicPlayerProfileListSchema
export type PublicPlayerProfilesState = Static<
  typeof PublicPlayerProfilesStateSchema
>

export const EMPTY_PLAYER_PROFILE_STORE: PlayerProfileStoreState = {}
export const EMPTY_GAMER_TAG_REGISTRY: GamerTagRegistryState = {}
export const EMPTY_PUBLIC_PLAYER_PROFILES: PublicPlayerProfilesState = []

export const GamerTagFormSchema = Type.Object({
  gamerTag: Type.String(),
  displayName: Type.String(),
})

export type GamerTagForm = Static<typeof GamerTagFormSchema>
